import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, Smartphone, CheckSquare, Calendar, Shield } from 'lucide-react';
export function PricingSection() {
  const includes = [{
    icon: FileText,
    text: 'PDF principal: el sistema completo (Protocolo 4F + rutina PM)'
  }, {
    icon: Smartphone,
    text: 'Tarjetas rápidas (móvil/imprimible): «si pasa X → haz Y»'
  }, {
    icon: CheckSquare,
    text: 'Checklist de preparación (10 min)'
  }, {
    icon: Calendar,
    text: 'Plan de 7 días: medir progreso sin obsesión'
  }, {
    icon: Shield,
    text: 'Plan B para días imposibles (y guión de turnos si hay pareja)'
  }];
  return <section className="py-12 px-4 md:px-6 bg-[#1a2e4a] text-[#faf6f0] relative overflow-hidden" data-id="element-117">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-118">
        <div className="absolute top-10 left-10 w-32 h-32 bg-[#c4956a] rounded-full opacity-5 blur-3xl" data-id="element-119"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-[#d4a0a0] rounded-full opacity-5 blur-3xl" data-id="element-120"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-121">
        <div className="text-center mb-8" data-id="element-122">
          <h2 className="font-serif text-2xl md:text-4xl font-bold mb-3 text-[#faf6f0]" data-id="element-123">
            Qué incluye
          </h2>
          <p className="text-[#faf6f0]/80 text-base" data-id="element-124">
            Todo lo que necesitas para recuperar la calma en las tardes.
          </p>
        </div>

        <div className="bg-[#faf6f0] text-[#1a2e4a] rounded-3xl p-5 md:p-8 shadow-2xl max-w-3xl mx-auto" data-id="element-125">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center" data-id="element-126">
            <div data-id="element-127">
              <ul className="space-y-4" data-id="element-128">
                {includes.map((item, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-3" data-id="element-129">
                    <div className="bg-[#1a2e4a]/10 p-1.5 rounded-lg text-[#1a2e4a]" data-id="element-130">
                      <item.icon size={18} data-id="element-131" />
                    </div>
                    <span className="text-[#5a5a5a] text-sm font-medium" data-id="element-132">
                      {item.text}
                    </span>
                  </motion.li>)}
              </ul>
            </div>

            <div className="bg-[#1a2e4a] p-6 rounded-2xl text-center text-[#faf6f0] flex flex-col justify-center" data-id="element-133">
              <span className="text-[#c4956a] font-bold tracking-wider uppercase text-xs mb-1" data-id="element-134">
                Oferta Especial
              </span>
              <div className="inline-block bg-[#c4956a] text-white text-xs font-bold px-3 py-1 rounded-full mb-2 tracking-wide mx-auto" data-id="element-135">
                −60% DESCUENTO
              </div>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-136">
                <span className="text-xl text-[#faf6f0]/40 line-through font-serif" data-id="element-137">
                  19€
                </span>
                <div className="text-5xl font-serif font-bold" data-id="element-138">6,39€</div>
              </div>
              <span className="text-[#faf6f0]/60 text-xs mb-4" data-id="element-139">
                Acceso inmediato
              </span>

              <p className="text-xs text-[#faf6f0]/80 mb-4 italic" data-id="element-140">
                «Si hoy estás viviendo el tramo crítico, hoy tienes el guion.»
              </p>

              <a href="https://plenava.com/cart/52227852173659id1:1" target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-141">
                <Button variant="primary" className="w-full bg-[#c4956a] hover:bg-[#b0845c] text-white border-none" data-id="element-142">
                  Quiero el kit (6,39€)
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-143">
          <h3 className="font-serif text-xl md:text-2xl font-bold mb-4 leading-tight" data-id="element-144">
            Si cada tarde‑noche se rompe y te deja vacía, no necesitas más
            opiniones. Necesitas un orden.
          </h3>
          <p className="text-base text-[#faf6f0]/80 mb-6" data-id="element-145">
            Consigue «Tu bebé tarde‑noche» y usa el Protocolo 4F esta misma
            noche.
          </p>
          <a href="https://plenava.com/cart/52227852173659id1:1" target="_blank" rel="noopener noreferrer" data-id="element-146">
            <Button size="lg" className="px-10 py-5 text-lg shadow-[#c4956a]/50" data-id="element-147">
              Quiero el kit (6,39€)
            </Button>
          </a>
        </div>
      </div>
    </section>;
}